import {
  FETCH_ENGLISH_KEYWORDS,
  FETCH_ENGLISH_KEYWORDS_SUCCESS,
  FETCH_ENGLISH_KEYWORDS_FAILED,
  SAVE_KEYWORDS_SUGGESTIONS,
  SAVE_KEYWORDS_SUGGESTIONS_SUCCESS,
  SAVE_KEYWORDS_SUGGESTIONS_FAILED,
  FETCH_KEYWORD_AUDIT,
  FETCH_KEYWORD_AUDIT_SUCCESS,
  FETCH_KEYWORD_AUDIT_FAILED,
  SAVE_KEYWORDS_AUDIT,
  SAVE_KEYWORDS_AUDIT_SUCCESS,
  SAVE_KEYWORDS_AUDIT_FAILED,
  SAVE_KEYWORD,
  SAVE_KEYWORD_SUCCESS,
  SAVE_KEYWORD_FAILED,
} from "./../constants/constants";

const initialState = {
  keywordList: {
    data: [],
    count: 0,
  },
  keywordAudit: {
    data: [],
    count: 0,
  },
  Count: "",
  success: {
    message: "",
  },
  error: {
    message: "",
  },
  loading: false,

  keywordCreate: {
    data: [],
  },
};

const CreatorDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENGLISH_KEYWORDS:
      return {
        ...state,
        loading: true,
        // success:{
        //     message:''
        // },
        // error:{
        //     message:''
        // },
      };
    case FETCH_ENGLISH_KEYWORDS_SUCCESS:
      return {
        ...state,
        loading: false,
        keywordList: action.data,
        Count: action.data.Count,
      };
    case FETCH_ENGLISH_KEYWORDS_FAILED:
      return {
        ...state,
      };
    case SAVE_KEYWORDS_SUGGESTIONS:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case SAVE_KEYWORDS_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: {
          message: "Keyword updated successfully!",
        },
      };
    case SAVE_KEYWORDS_SUGGESTIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          message: "Keyword update failed",
        },
      };
    case FETCH_KEYWORD_AUDIT:
      return {
        ...state,
        loading: true,
        // success:{
        //     message:''
        // },
        // error:{
        //     message:''
        // },
      };
    case FETCH_KEYWORD_AUDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        keywordAudit: action.data,
        Count: action.data.Count,
      };
    case FETCH_KEYWORD_AUDIT_FAILED:
      return {
        ...state,
      };
    case SAVE_KEYWORDS_AUDIT:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case SAVE_KEYWORDS_AUDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: {
          message: "Keyword updated successfully!",
        },
      };
    case SAVE_KEYWORDS_AUDIT_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          message: "Keyword update failed",
        },
      };

    case SAVE_KEYWORD:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case SAVE_KEYWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        keywordCreate: {
          data: action.data || [],
        },
        success: {
          message: "Keyword inserted successfully!",
        },
      };
    case SAVE_KEYWORD_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          message: "Keyword Insert failed",
        },
      };
    default:
      return state;
  }
};

export default CreatorDashboardReducer;
